import PropTypes from 'prop-types';
import { Avatar } from '@mui/material'

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringToAvatar(text, size, sx) {
  return {
    sx: {
      ...{
        bgcolor: stringToColor(text)
      }, ...(size == 'small' ? {
        width: 32,
        height: 32,
        fontSize: 14
      } : {}),
      ...sx
    },
    children: text == '' ? '' : `${text.split(' ')[0][0]}${text.split(' ')[1] ? text.split(' ')[1][0] : ''}`,
  };
}

export default function StringAvatar({ text, size, sx, ...others }) {
  return (
    <Avatar {...stringToAvatar(text, size, sx)} {...others} />
  );
}

StringAvatar.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.string,
  sx: PropTypes.object,
  others: PropTypes.any
};